/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Leave_Parts_At_PudoInputs */

const en_ticket_action_leave_parts_at_pudo = /** @type {(inputs: Ticket_Action_Leave_Parts_At_PudoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave Parts at PUDO`)
};

const ja_ticket_action_leave_parts_at_pudo = /** @type {(inputs: Ticket_Action_Leave_Parts_At_PudoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品をPUDOに預ける`)
};

const fr_ticket_action_leave_parts_at_pudo = /** @type {(inputs: Ticket_Action_Leave_Parts_At_PudoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déposer les pièces au PUDO`)
};

const de_ticket_action_leave_parts_at_pudo = /** @type {(inputs: Ticket_Action_Leave_Parts_At_PudoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile an PUDO abgeben`)
};

/**
* | output |
* | --- |
* | "Leave Parts at PUDO" |
*
* @param {Ticket_Action_Leave_Parts_At_PudoInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_leave_parts_at_pudo = /** @type {((inputs?: Ticket_Action_Leave_Parts_At_PudoInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Leave_Parts_At_PudoInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_leave_parts_at_pudo(inputs)
	if (locale === "ja") return ja_ticket_action_leave_parts_at_pudo(inputs)
	if (locale === "fr") return fr_ticket_action_leave_parts_at_pudo(inputs)
	return de_ticket_action_leave_parts_at_pudo(inputs)
});